import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=2d2576be&scoped=true"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"
import style0 from "./Resultados.vue?vue&type=style&index=0&id=2d2576be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2576be",
  null
  
)

export default component.exports